// extracted by mini-css-extract-plugin
export var content = "_af-3";
export var list = "_af-4";
export var settingsContent = "_af-7";
export var settingsPanel = "_af-8";
export var state = "_af-6";
export var triggerBadge = "_af-2";
export var triggerButton = "_af-1";
export var triggerShell = "_af-0";
export var unreadDot = "_af-5";